import React, { useState } from "react";
import Navbar from "../Navbar/Navbar"
import "./AddStudent.css";
import { useSelector } from "react-redux";
import { useCreateChildrenMutation } from "../../../Redux/Api/AuthApi";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../MiddleWay/useAuth";

const AddStudent = () => {
   const {detailEnrolls} = useSelector((state)=>state.Auth)
   const [createChildren,{isLoading,isSuccess}] = useCreateChildrenMutation()
   const {id} = useAuth()

   const [formData,setFormData] = useState({
    firstName:"",
    lastName:"",
    gender:detailEnrolls?.gender,
    healthCondition:"",
    classId:detailEnrolls?._id,
    age:detailEnrolls?.age,
    parentId:id,
    gymnasticLevel:"",
    clinicPreference:"",
    insuranceCarrier:"",
    physicianPhone:""
   })
   const navigate = useNavigate()
   const [msg,setMsg] = useState()

   const handleChange = (e)=>{
     const {name,value} = e.target
     setFormData((prev)=>({...prev,[name]:value}))
   }
   const handleSubmit = async(e)=>{
    e.preventDefault()
     const response = await createChildren(formData)
     if(response?.data){
      navigate('/portal/dashboard/account')
     }
     setMsg("Failed")
   }

  return (
    <div className="kiga-portal-addStudent-main">
      <Navbar />
      <section className="kiga-portal-addStudent-section">
      <form onSubmit={handleSubmit}>
        <div className="kiga-portal-addStudent-section-title-name">
          <p>Children Details</p>
        </div>

        <div className="kiga-portal-addStudent-section-form">
          <div className="kiga-portal-addStudent-section-form-title">
            <p>General Information</p>
          </div>
          <div className="kiga-portal-addStudent-section-form-name-flex">
            <div className="kiga-portal-addStudent-section-form-name-label">
              <label>
                Name:<span>*</span>
              </label>
            </div>
            <div className="kiga-portal-addStudent-section-form-fname">
              <input type="text" placeholder="First Name" name="firstName" onChange={handleChange}/>
              <label>First Name</label>
            </div>
            <div className="kiga-portal-addStudent-section-form-lname">
              <input type="text" placeholder="Last Name" name="lastName" onChange={handleChange} />
              <label>Last Name</label>
            </div>
          </div>
          <div className="kiga-portal-addStudent-section-form-condition-flex">
            <div className="kiga-portal-addStudent-section-form-condition-label">
              <label>Allergies / Special Health Conditions:</label>
            </div>

            <div className="radio-group">
              <label>
                <input type="radio" name="healthCondition" onChange={handleChange}/>
                Yes
              </label>

              <label>
                <input type="radio" name="healthCondition" onChange={handleChange}/>
                No
              </label>
            </div>
          </div>
          <div className="kiga-portal-addStudent-section-form-condition-flex">
            <div className="kiga-portal-addStudent-section-form-condition-label">
             <label>Choose a Gymnastic Level:</label>
            </div>
            <div className="kiga-portal-addStudent-section-form-lname">
             <select name="gymnasticLevel" id="gymnasticLevel" onChange={handleChange}>
              <option value="beginner">Beginner</option>
              <option value="intermediate">intermediate</option>
              <option value="advance">Advance</option>
             </select>
            </div>
          </div>
        </div>
        <div className="kiga-portal-medical-section-form">
          <div className="kiga-portal-medical-section-form-title">
            <p>Student Medical Information</p>
          </div>
          <div className="kiga-portal-medical-section-form-clinic-flex">
            <div className="kiga-portal-medical-section-form-clinic-label">
              <label>
                Hospital / Clinic Preference:<span>*</span>
              </label>
            </div>
            <div className="kiga-portal-medical-section-form-clinic">
              <input type="text" name="clinicPreference" onChange={handleChange}/>
            </div>
          </div>
          <div className="kiga-portal-medical-section-form-clinic-flex">
            <div className="kiga-portal-medical-section-form-clinic-label">
              <label>
               Insurance Carrier / Company:<span>*</span>
              </label>
            </div>
            <div className="kiga-portal-medical-section-form-clinic">
              <input type="text" name="insuranceCarrier" onChange={handleChange}/>
            </div>
          </div>
          <div className="kiga-portal-medical-section-form-clinic-flex">
            <div className="kiga-portal-medical-section-form-clinic-label">
              <label>
               Physician Phone:<span>*</span>
              </label>
            </div>
            <div className="kiga-portal-medical-section-form-clinic">
              <input type="text" name="physicianPhone" onChange={handleChange}/>
            </div>
          </div>
        </div>
        <div className="kiga-portal-addStudent-btn">
          <button type="submit">{isLoading ? 'Loading...' : 'Save'}</button>
        </div>
      </form>
      </section>
    </div>
  );
};

export default AddStudent;
